import PropTypes from 'prop-types';
import { DndContext, closestCorners } from '@dnd-kit/core';
import {
  SortableContext,
  verticalListSortingStrategy,
  arrayMove,
} from '@dnd-kit/sortable';
import { Box } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { learningPlanCourseActions } from 'store/modules/learningPlanCourse/learningPlanCourse-slice';

import { updateLearningPlanCourseOrderNoAction } from 'store/modules/learningPlanCourse/learningPlanCourse-action';

import useToastNotif from 'hooks/useToastNotif';
import { useEffect } from 'react';
import { ReducerStatus } from 'utils/constants';
import {
  TOAST_ERROR,
  TOAST_LOADING,
  TOAST_SUCCESS,
} from 'utils/constants/toast';

import LearningPlanCourse from './LearningPlanCourse';

function LearningPlanCourseList({ learningPlanCourses, isPreviewMode }) {
  const dispatch = useDispatch();
  const { generateToastNotif } = useToastNotif();

  const learningPlan = useSelector((state) => state.learningPlan.learningPlan);
  const updateLearningPlanCourseOrderNo = useSelector(
    (state) => state.learningPlanCourse.updateLearningPlanCourseOrderNo
  );

  const handleChangeOrderNo = (event) => {
    const { active, over } = event;

    if (active.id === over.id) return;

    const originalPos = learningPlanCourses.findIndex(
      (item) => item.id === active.id
    );
    const newPos = learningPlanCourses.findIndex((item) => item.id === over.id);

    dispatch(
      learningPlanCourseActions.setLearningPlanCourses(
        arrayMove(learningPlanCourses, originalPos, newPos)
      )
    );

    dispatch(
      updateLearningPlanCourseOrderNoAction({
        id: learningPlan.id,
        courseId: learningPlanCourses.find((course) => course.id === active.id)
          .course.id,
        newOrderNo: newPos + 1,
      })
    );
  };

  useEffect(() => {
    if (updateLearningPlanCourseOrderNo.status === ReducerStatus.LOADING) {
      generateToastNotif(TOAST_LOADING, 'Saving', 'Please wait', true, false);
    } else if (
      updateLearningPlanCourseOrderNo.status === ReducerStatus.FAILED
    ) {
      generateToastNotif(
        TOAST_ERROR,
        updateLearningPlanCourseOrderNo.error?.data?.status || 'Failed',
        updateLearningPlanCourseOrderNo.error?.data?.title ||
          'Something went wrong with the request.',
        true,
        true
      );
    } else if (
      updateLearningPlanCourseOrderNo.status === ReducerStatus.SUCCEEDED
    ) {
      generateToastNotif(
        TOAST_SUCCESS,
        'Saved',
        'Order number has been updated.',
        true,
        true
      );
    }
  }, [updateLearningPlanCourseOrderNo, generateToastNotif]);

  return (
    <DndContext
      onDragEnd={handleChangeOrderNo}
      collisionDetection={closestCorners}
    >
      <SortableContext
        items={learningPlanCourses}
        strategy={verticalListSortingStrategy}
      >
        <Box>
          {learningPlanCourses.map((learningPlanCourse) => (
            <LearningPlanCourse
              key={learningPlanCourse.id}
              id={learningPlanCourse.id}
              course={learningPlanCourse.course}
              isPreviewMode={isPreviewMode}
            />
          ))}
        </Box>
      </SortableContext>
    </DndContext>
  );
}

LearningPlanCourseList.defaultProps = {
  isPreviewMode: false,
};

LearningPlanCourseList.propTypes = {
  learningPlanCourses: PropTypes.array.isRequired,
  isPreviewMode: PropTypes.bool,
};

export default LearningPlanCourseList;
